import request from '@/utils/request';
//规则管理列表
export function getRuleDetailList(param) {
  return request('/decision/rule/rule-output-result', {
    method: 'GET',
    params: param,
  });
}

//新增规则管理列表
export function addRuleDetailList(values) {
  return request('/decision/rule/rule-output-result', {
    method: 'POST',
    data: values,
  });
}
//编辑规则管理列表
export function editRuleManaList(values) {
  const { id } = values || {};
  delete values['id'];
  return request(`/decision/rule/rule-output-result/${id}`, {
    method: 'PUT',
    data: values,
  });
}
//删除规则管理列表
export function deleteRuleManaList(values) {
  const { id } = values || {};
  return request(`/decision/rule/rule-output-result/${id}`, {
    method: 'DELETE',
    // data: values,
  });
}
//批量删除规则管理列表
export function deleteBatchRuleManaList(values) {
  return request('/decision/rule/rule-output-result/batchDelete', {
    method: 'POST',
    data: values,
  });
}
//获取所有的字段包信息
export function getAllFieldPackage() {
  return request('/decision/field/field-package/all', {
    method: 'GET',
  });
}
//获取所有的字段包信息
export function getFieldPackageDetails(values) {
  return request('/decision/field', {
    method: 'GET',
    params: values,
  });
}
// 导入单个列表
export function importSingle(values, id) {
  return request(`/decision/rule/rule-output-result/${id}/import/single`, {
    method: 'POST',
    data: values,
  });
}
// 导入多个列表
export function importMultiple(values, id) {
  delete values['id'];
  return request(`/decision/rule/rule-output-result/${id}/import/multiple`, {
    method: 'POST',
    data: values,
  });
}
//批量粘贴规则数据
export function pasteRule(values) {
  return request('/decision/rule/rule-output-result/paste', {
    method: 'POST',
    data: values,
  });
}
